<template>
  <div class="instant-discount-rule" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" >
      <el-form-item label="即时优惠使用规则名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入即时优惠使用规则名称"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleAdd" v-permission="'0310201'">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="code"
        label="即时优惠使用规则编码"
        width="150"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="name"
        label="即时优惠使用规则名称"
        width="150"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatStatus"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="使用规则有效期"
        width="180"
        show-overflow-tooltip>
        <template slot-scope="scope">{{(scope.row.effectiveStartDate || '').slice(0, 10)}}-{{(scope.row.effectiveEndDate || '').slice(0, 10)}}</template>
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="创建人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="150"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="applyVerifyTime"
        label="提交审核时间"
        width="150"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="verifyTime"
        label="审核时间"
        width="150"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invalidCardNo"
        label="作废人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invalidTime"
        label="作废时间"
        width="150"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invalidReason"
        label="作废内容"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="300" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button @click="handleInfoView(scope.row)" v-permission="'0310203'">查看</el-button>
          <el-button @click="handleDel(scope.row)" v-if="scope.row.status === 0" v-permission="'0310207'">删除</el-button>
          <el-button @click="handleAdd(scope.row)" v-if="scope.row.status === 0" v-permission="'0310204'">编辑</el-button>
          <el-button @click="handleApprove(scope.row)" v-if="scope.row.status === 0" v-permission="'0310206'">提交审核</el-button>
          <el-button v-if="isInvalid(scope.row)" @click="handleInvalid(scope.row)" v-permission="'0310205'">作废</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNum"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end" v-permission="'0310202'">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.pageSize" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.pageNum">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
    <invalid-dialog :show.sync="invalidDialogVisible" :formData="invalidInfo" :handleSearch="handleSearch"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import invalidDialog from './invalidDialog.vue'
export default {
  name: 'instantDiscountsUseRule',
  components: { invalidDialog },
  data () {
    return {
      form: {
        name: '',
        status: ''
      },
      invalidDialogVisible: false,
      invalidInfo: {},
      statusArr: [
        { value: '', label: '全部' },
        { value: 0, label: '待提交' },
        { value: 1, label: '待审核' },
        { value: 2, label: '待生效' },
        { value: 3, label: '已生效' },
        { value: 4, label: '审核未通过' },
        { value: 5, label: '已失效' },
        { value: 6, label: '已作废' }
      ],
      exportForm: {
        pageSize: 1000,
        pageNum: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ]
    }
  },
  computed: {
    ...mapGetters({ list: 'getInstantDiscountUseRuleList', listState: 'getInstantDiscountUseRuleListState' }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  methods: {
    ...mapActions(['getInstantDiscountUseRuleList', 'exportInstantDiscountUseRuleList', 'deleteInstantDiscountUSeRule', 'invalidInstantDiscountUseRule', 'auditInstantDiscountUSeRule']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      this.getInstantDiscountUseRuleList({ ...this.form, pageNum: 1, pageSize: 10 })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getInstantDiscountUseRuleList({ pageSize: val, pageNum: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getInstantDiscountUseRuleList({ pageNum: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.pageNum = 1
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportInstantDiscountUseRuleList({ ...this.form, ...this.exportForm }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '即时优惠使用规则报表.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    // 新增
    handleAdd (row) {
      let query = {}
      if (row.id) {
        query.id = row.id
        query.type = 'edit'
      }
      this.$router.push({ name: 'addInstantDiscountsRule', query })
    },
    // 查看
    handleInfoView (row) {
      this.$router.push({ name: 'lookInstantDiscountsRule', query: { id: row.id } })
    },
    handleDel (row) {
      this.$confirm('是否删除？', '删除提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteInstantDiscountUSeRule({ id: row.id }).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.handleSearch()
        })
      }).catch(() => {})
    },
    // 判断是否可以作废
    isInvalid (row) {
      if ([2, 3].includes(row.status)) {
        return true
      } else {
        return false
      }
    },
    // 作废
    handleInvalid (row) {
      this.invalidDialogVisible = true
      this.invalidInfo = row
    },
    // 格式化状态
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    },
    handleApprove (row) {
      this.$confirm('提交审核后发起审批流程，是否确认提交', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.auditInstantDiscountUSeRule({ id: row.id })
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.handleSearch()
      }).catch(() => {
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style lang="scss" scoped>
.width100 {
  width: 100px;
}
.export-row {
  margin-top: 10px;
}
</style>
